// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'presentation';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.688 2.813a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0zm5.625 7.875V9.562a3.375 3.375 0 0 0-6.75 0v2.25h1.125l.562 5.626h3.375l.506-5.063m3.432-2.812h6.75a1.125 1.125 0 0 0 1.125-1.126v-6.75A1.125 1.125 0 0 0 16.313.563H8.438m6.75 6.75H9.561M7.97 13.781a1.969 1.969 0 1 0 3.937 0 1.969 1.969 0 0 0-3.938 0zm4.405 3.657a3.203 3.203 0 0 0-4.875 0m5.532-3.657a1.969 1.969 0 1 0 3.938 0 1.969 1.969 0 0 0-3.938 0zm4.406 3.657a3.203 3.203 0 0 0-4.875 0m1.5-10.125v-4.5m-2.25 4.5V4.5'
  />
);

export const viewBox = '0 0 18 18';
